























import { Component, Vue, Ref, Prop, Watch } from 'vue-property-decorator'
import DataTableDeCrud from '../ui/DataTableDeCrud.vue'
import { GrupoDeCliente } from '@/models'
import { DataOptions } from 'vuetify'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import axios, { CancelTokenSource } from 'axios'
import DialogoDeVincularGrupoDeCliente from './DialogoDeVincularGrupoDeCliente.vue'
import { GrupoDeClienteUseCase } from '@/usecases/cliente/GrupoDeClienteUseCase'


@Component({
	components: {
		DataTableDeCrud,
		DialogoDeVincularGrupoDeCliente,
	},
})
export default class ListagemDosGruposDeCliente extends Vue {
	@Prop({ type: String }) clienteId!: string
	@Ref() dialogoDeVincularGrupoDeCliente!: DialogoDeVincularGrupoDeCliente

	carregando = true
	loading = false
	mostrar = false

	totalRegistros = -1

	headers = [
		{ text: 'Nome', value: 'nome', sortable: false },
		{ text: 'Grupo Econômico', value: 'grupoEconomico.descricao', sortable: false},
	]

	cancelToken: CancelTokenSource | null = null

	gruposDeCliente: GrupoDeCliente[] | [] = []
	grupoDeClienteUseCase = new GrupoDeClienteUseCase()
	
	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 5,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	abrirDialogoDeVincularGrupos() {
		this.dialogoDeVincularGrupoDeCliente.mostrar()
	}

	@Watch('mostrar')
	created() {
		if(!this.mostrar) return 
		this.buscar()
	}

	@Watch('paginacao')
	async buscar () {
		if(!this.clienteId) return
		try {
			this.cancelToken = axios.CancelToken.source()

			const params = {
				page: this.paginacao.page - 1,
				clienteId: this.clienteId || undefined,
				size: this.paginacao.itemsPerPage,
			}
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			const pagina = await this.grupoDeClienteUseCase.findGruposVinculadosComCliente(params, axiosConfig)
			this.gruposDeCliente = pagina.content
			this.totalRegistros = pagina.totalElements
			this.carregando = false
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
			this.carregando = false
		}
	}

	async vincularGrupo(grupo: GrupoDeCliente) {
		try {
			const existeRelacao = await this.grupoDeClienteUseCase.possuiGrupoDeClienteByGrupoEconomico(this.clienteId, grupo.id)
			if (existeRelacao) return AlertModule.setError("Cliente já tem um grupo de cliente relacionado para este mesmo Grupo Econômico.")
			await this.grupoDeClienteUseCase.vincularGrupoDeCliente(this.clienteId, grupo.id)
		} catch(e) {
			AlertModule.setError(e)
		} finally {
			this.buscar()
		}
	}

	async desvincularGrupo(indice: number) {
		this.loading = true
		const grupoSelecionado = this.gruposDeCliente[indice]
		try {
			await this.grupoDeClienteUseCase.desvincularGrupoDeCliente(grupoSelecionado.id, this.clienteId)
		} catch(e) {
			this.loading = false
			console.log(e)
			AlertModule.setError(e)
		} finally {
			this.loading = false
			this.gruposDeCliente.splice(indice, 1)
			this.$emit("delete:grupos", grupoSelecionado)
			this.buscar()
			AlertModule.setSuccess("Grupo desvinculado com sucesso")
		}
	}

}
